// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoContainer[data-v-56bd85d9]{padding:10px 0}.infoContainer .top p[data-v-56bd85d9]{text-align:center;margin:0}[data-v-56bd85d9]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
